import React, { HTMLAttributes, HTMLProps } from 'react';
import Immutable from 'immutable';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ImmutableBadgeTaxonomyEntity } from '../../../implementations/Taxonomy';
import useClasses from '../../../hooks/useClasses';
import Badge from '../../Badge';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  badge: ImmutableBadgeTaxonomyEntity;
}

const PopupBadge: React.FC<Props> = ({ badge, className }) => {
  const { buildClass, joinClasses } = useClasses('PopupBadge');

  const name = badge.getIn(['name', 0, 'value'], '');
  const description = badge.getIn(['description', 0, 'processed'], '');
  const image = badge.getIn(['field_image', 0, 'entity', 'field_media_file', 0], Immutable.Map());

  return (
    <div className={joinClasses(buildClass(), className)}>
      <div className={buildClass('hero')}>
        <Badge image={image} size="xxl" />
        <div className={buildClass('name')}>
          <h3 className="asH5">{name}</h3>
        </div>
      </div>

      <div className={buildClass('description')}>
        <WysiwygField
          property="schema:text"
          html={description}
        />
      </div>
    </div>
  );
};

export default PopupBadge;
